export function todaysMeanValue (station) {
  return station.properties.todaysHourValues.reduce((prev, next) => prev + next) / station.properties.todaysHourValues.length
}

export function latestValue (station) {
  if (station.properties.todaysHourValues.length === 0) return -1
  return station.properties.todaysHourValues[station.properties.todaysHourValues.length - 1].y
}

export function todaysMin (station) {
  return station.properties.todaysHourValues.reduce((prev, next) => next.y < prev ? next.y : prev, Number.MAX_VALUE)
}

export function todaysMax (station) {
  return station.properties.todaysHourValues.reduce((prev, next) => next.y > prev ? next.y : prev, 0)
}

export function yearMin (station) {
  return station.properties.last12MonthsMedians.reduce((prev, obj) => obj.y < prev ? obj.y : prev, Number.MAX_VALUE)
}

export function yearMax (station) {
  return station.properties.last12MonthsMedians.reduce((prev, obj) => obj.y > prev ? obj.y : prev, 0)
}

export function yearMeanValue (station) {
  return station.properties.last12MonthsMedians.reduce((prev, obj) => prev + obj.y, 0) / station.properties.last12MonthsMedians.length
}

export default { latestValue, todaysMin, todaysMax, yearMin, yearMax, yearMeanValue }
